export const REASON_AGREED = "agreed";
export const REASON_PRE_FILLED = "pre-filled";
export const REASON_ANSWERED_BEFORE = "answered before";
export const REASON_REPEATED_CONCEPT = "repeated concept";
export const REASON_UNIT_MISSING = "unit missing";
export const REASON_NO_MAJORITY = "no majority";

export const LEAF_EXISTING = "existing";
export const LEAF_NEW = "new";
export const OLDER_HISTORY = "older history";

export const UNCHECKED_MATCHES = ["ai", "new", "not checked"];

export const WARNING_TWO_SAVED_ANSWERS = "two saved answers on one field";

// ponytail: waits for warning codes on the item. Intent: hide the new-pool warning. Breaks if the engine rewords it.
export const NEW_POOL_WARNING = "new pool suggested";
